import { combineReducers } from 'redux';
import CustomersReducer from './Party/CustomerReducer/CustomerReducer';
import InvoiceReducer from './InvoiceReducer/InvoiceReducer';
import PettyCashReducer from './PettyCashReducer/PettyCashReducer';
import StockOutReducer from './Stock/StockOutReducer/StockOutReducer';
import StockInReducer from './Stock/StockInReducer/StockInReducer';
import PortReducer from './PortReducer/PortReducer';
import InvoiceLedgerReducer from './InvoiceLedgerReducer/InvoiceLedgerReducer';

const partyReducer = combineReducers({
  customer: CustomersReducer
});
const stockReducer = combineReducers({
  stockIn: StockInReducer,
  stockOut: StockOutReducer
});

// Combine both reducers into a single root reducer
const rootReducer = combineReducers({
  PRT: partyReducer,
  PC: PettyCashReducer,
  invoice: InvoiceReducer,
  stock: stockReducer,
  port: PortReducer,
  ledger: InvoiceLedgerReducer
});

export default rootReducer;
